import { FC } from 'react'

// eslint-disable-next-line import/no-extraneous-dependencies
import { Button } from 'baby-design'
// eslint-disable-next-line import/no-extraneous-dependencies
import { LinkOut } from 'baby-design/icons'

import { TrackingInfo } from 'src/types/shipments'

import LabelAndInfo from '../LabelAndInfo'
import styles from './TrackingInfoRow.styles.scss'

const TrackingInfoRow: FC<{ trackingInfo: TrackingInfo }> = ({
  trackingInfo: { url, number },
}) => {
  if (!url) {
    return null
  }

  return (
    <div className={styles.TrackingInfoRow} data-testid="TrackingInfoRow">
      <LabelAndInfo info={number} label="Tracking" />
      <Button
        data-testid="TrackingInfoRow__Button"
        href={url}
        icon={{
          side: 'right',
          icon: <LinkOut />,
          size: 'sm',
        }}
        size="sm"
        target="_blank"
        variant="tertiary"
      >
        Track
      </Button>
    </div>
  )
}

export default TrackingInfoRow
